import { render } from "./VacunaPersTabla02.vue?vue&type=template&id=523315a2&scoped=true"
import script from "./VacunaPersTabla02.vue?vue&type=script&lang=js"
export * from "./VacunaPersTabla02.vue?vue&type=script&lang=js"

import "./VacunaPersTabla02.vue?vue&type=style&index=0&id=523315a2&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-523315a2"]])

export default __exports__